/**
 * Sélecteurs pour la gestion de la session
 * @category Store
 * @hideconstructor
 */
var SessionStoreSelector = /*#__PURE__*/function () {
  function SessionStoreSelector() {}

  /**
   * Sélection de l'objet contenant les informations de session
   * @param {object} state state de l'application
   * @returns {SessionObject} Informations de session
   */
  SessionStoreSelector.selectSession = function selectSession(state) {
    return state.manageSession.session;
  }
  /**
   * Sélection de l'identifiant de session
   * @param {object} state state de l'application
   * @returns {string} Variable contenant l'identifiant de session
   */
  ;

  SessionStoreSelector.selectSessionId = function selectSessionId(state) {
    return SessionStoreSelector.selectSession(state).id;
  }
  /**
   * Sélection de la variable permettant de savoir si la session reste ouverte ou non
   * @param {object} state state de l'application
   * @returns {boolean} Variable permettant de savoir si la session reste ouverte ou non
   */
  ;

  SessionStoreSelector.selectSessionStayConnect = function selectSessionStayConnect(state) {
    return SessionStoreSelector.selectSession(state).stayConnect;
  }
  /**
   * Sélection de la date et heure de la dernière requête
   * @param {object} state state de l'application
   * @returns {date} Variable contenant la date et heure de la dernière requête
   */
  ;

  SessionStoreSelector.selectSessionLastRequest = function selectSessionLastRequest(state) {
    return SessionStoreSelector.selectSession(state).lastRequest;
  };

  return SessionStoreSelector;
}();

export var selectSession = SessionStoreSelector.selectSession;
export var selectSessionId = SessionStoreSelector.selectSessionId;
export var selectSessionStayConnect = SessionStoreSelector.selectSessionStayConnect;
export var selectSessionLastRequest = SessionStoreSelector.selectSessionLastRequest;